import DateAdapter from '@src/utils/DateAdapter'
import EvaluacionProductividad from '../../domain/entities/EvaluacionProductividad'
import { VUETIFY_DATE_FORMAT } from '@src/const'

export class EvaluacionProductividadAdapter {
  static toEntity(dto) {
    const entity = new EvaluacionProductividad(dto.fkidPersonalEvaluador)
    entity.id = dto.id
    entity.idEvaluado = dto.fk_idPersonal
    entity.evaluado = dto.Personal
    entity.idEvaluador = dto.fkidPersonalEvaluador
    entity.puntajeTotal = dto.puntajeTotal
    entity.calificacion = dto.calificacion
    entity.fechaAplicacion = dto.fechaAplicacion
    entity.fechaInicio = dto.fechaInicial
    entity.fechaConclusion = dto.fechaFin
    entity.idResultado = dto.fkidResultado
    entity.resultado = dto.CatResultado?.title || ''
    entity.idEstatus = dto.fk_idCatEstatusEvaluacion
    entity.estatus = dto.CatEstatusEvaluacion?.title || ''
    entity.reactivos = Array.isArray(dto.niveles)
      ? dto.niveles.map((nivel) => ({
          realizados: nivel.realizados,
          idCatFrecuencia: nivel.fk_idCatFrecuencia,
          idIndicadorEvaluacion: nivel.fk_idIndicadorEvaluacion,
        }))
      : []
    entity.factoresMerito = Array.isArray(dto.factores)
      ? dto.factores.map((factor) => ({
          cantidad: factor.cantidad,
          descripcion: factor.descripcion,
          idActoRelevanteEvaluacion: factor.fk_idActoRelevanteEvaluacion,
        }))
      : []
    return entity
  }

  static toDto(entity) {
    return {
      id: entity.id,
      puntajeTotal: entity.puntajeTotal ?? 0,
      calificacion: entity.calificacion ?? 0,
      fechaAplicacion: new DateAdapter(entity.fechaAplicacion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaInicial: new DateAdapter(entity.fechaInicio, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaFin: new DateAdapter(entity.fechaConclusion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fkidPersonalEvaluador: entity.idEvaluador,
      fk_idPersonalEvaluado: entity.idEvaluado,
      fkidResultado: entity.idResultado ?? 1,
      fk_idCatEstatusEvaluacion: entity.idEstatus ?? 1,
      niveles: Array.isArray(entity.reactivos)
        ? entity.reactivos.map((nivel) => ({
            realizados: nivel.realizados,
            fk_idCatFrecuencia: nivel.idCatFrecuencia,
            fk_idIndicadorEvaluacion: nivel.idIndicadorEvaluacion,
          }))
        : [],
      factores: Array.isArray(entity.factoresMerito)
        ? entity.factoresMerito.map((factor) => ({
            cantidad: factor.cantidad,
            descripcion: factor.descripcion,
            fk_idActoRelevanteEvaluacion: factor.idActoRelevanteEvaluacion,
          }))
        : [],
    }
  }
}
